// The table's caption: its configured accessible name. A caption that repeats the visible title is
// available only to screen readers, as is an embedded table's caption; any other caption is visible.

import React from 'react'

import { useTable } from '../context'

const comparable = text =>
  String(text || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()

export const captionRepeatsTitle = config =>
  comparable(config.caption) === comparable(config.title)

export const Caption = () => {
  const { config, captionId } = useTable()
  return (
    <caption
      id={captionId}
      className={
        config.embedded || captionRepeatsTitle(config)
          ? 'sr-only'
          : 'me-table-caption'
      }
    >
      {config.caption}
    </caption>
  )
}
